// <script src="{{ 'corona-custom.js' | asset_url }}" defer></script>

document.addEventListener("DOMContentLoaded", function() {
  // if (window.location.href.indexOf('/wheelbarrows/') !== -1) {
  //     console.log('wheelbarrows');
  //   document.body.classList.add('wheelbarrows-page');
  //   var comingSoonText = document.querySelector('body.wheelbarrows-page .variant-inventory h4 span');
  //   comingSoonText.textContent = 'Call to Order';
  // }


  

  if (window.location.href === 'https://coronatools.com/account/login') {
    window.location.href = 'https://coronatools.com';
  }

    if (window.location.href === 'https://coronatools.com/account/login?return_url=%2Faccount') {
    window.location.href = 'https://coronatools.com';
  }

  const urlPattern = /^https:\/\/coronatools\.com\/default\/catalog-tools\/.*$/;
  if (urlPattern.test(window.location.href)) {
    window.location.href = 'https://coronatools.com/collections';
  }




  
  const button = document.querySelector('.shopify-payment-button__button');
  if (button.getAttribute('aria-disabled') === 'true') {
    button.style.display = 'none';
  }
});
console.log('corona-custom js');
if (window.location.href.includes('resource-center')) {
  const links1 = document.querySelectorAll('a.bottompad-quarter');
  const links2 = document.querySelectorAll('.toppad-quarter a');
  const links3 = document.querySelectorAll('.product-loop a');


  // Iterate over the links
  for (const link of links1) {
    // Add a click event listener to the link
    link.addEventListener('click', (event) => {
      // Open the link in a new tab
      window.open(link.href, '_blank');

      // Prevent the default link behavior
      event.preventDefault();
    });
  }

    for (const link of links2) {
    // Add a click event listener to the link
    link.addEventListener('click', (event) => {
      // Open the link in a new tab
      window.open(link.href, '_blank');

      // Prevent the default link behavior
      event.preventDefault();
    });
  }
  for (const link of links3) {
    // Add a click event listener to the link
    link.addEventListener('click', (event) => {
      // Open the link in a new tab
      window.open(link.href, '_blank');

      // Prevent the default link behavior
      event.preventDefault();
    });
  }
}

const pagination = document.querySelector('ul.pagination');

// const links = pagination.querySelectorAll('a');

// links.forEach(link => {
//   link.href = link.href.replace(/_6e7acf60/g, '');
// });

const fileInput = document.querySelector('input[type="file"]');

fileInput.addEventListener('change', function() {

  const file = this.files[0];
  const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

  if (!allowedTypes.includes(file.type)) {
    alert("Invalid file type. Please upload a JPG, PNG, or PDF file.");
    this.value = ''; // Clear the file input
    return false;

  }


});

